import styled, { createGlobalStyle } from "styled-components";

// Global Styles
export const HelperStyle = createGlobalStyle`
    *,
    ::after,
    ::before
    {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    } 
    ul
    {
        list-style-type: none;
    }
    a
    {
        text-decoration: none;
    }
    /* Override Toggle margin solo en esta página: margin-bottom 8px → margin-top 2px */
    .identity-form .ms-Toggle
    {
        margin-bottom: 0;
        margin-top: 2px;
    }
`;

// Styled Components
export const Cont = styled.div`
    grid-area: main;
    background-color: ${(props) => props.theme.palette.white};
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
`;

export const MainCont = styled.div`
    padding: 20px 30px 30px 55px;

    @media screen and (max-width: 599px)
    {
        padding: 20px 25px 40px 25px;
    }

    @media screen and (max-width: 420px)
    {
        padding: 20px 8px 40px 8px;
    }
`;

export const Title = styled.div`
    margin-top: 10px;
    cursor: default;

    h1
    {
        font-size: 30px;
        color: #2a4143;
        font-weight: 800;
    }
`;

/** Subtítulo y botón «¿Necesitas asistencia?» en la misma línea (como en IdentitiesMainScreen). */
export const TitleSubtitleAssistRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-top: 5px;
    flex-wrap: wrap;

    h2
    {
        font-size: 24px;
        font-weight: 400;
        color: #5f7172;
        margin: 0;
        flex: 1 1 0;
        min-width: min(100%, 240px);
    }

    .identity-form-title-assist-trigger
    {
        flex-shrink: 0;
        display: flex;
        justify-content: flex-end;
    }

    .identity-form-title-assist-trigger > div
    {
        width: auto !important;
    }

    @media screen and (max-width: 599px)
    {
        flex-direction: column;
        align-items: stretch;

        h2
        {
            min-width: unset;
        }

        .identity-form-title-assist-trigger
        {
            justify-content: center;
        }
    }
`;

export const BarCont = styled.div`
    width: 100%;
    margin-top: 15px;
    margin-bottom: 15px;
`;

export const BgBar = styled.hr`
    width: 100%;
    border: solid 1px #eff4f6;
    margin: 0;
`;

export const FormContainer = styled.div`
    background: ${(props) => props.theme.palette.tertiary};
    width: 100%;
    padding: 30px;
    border-radius: 20px;
    margin-bottom: 20px;
    transition: opacity 0.3s ease;

    &.locked
    {
        opacity: 0.6;
        pointer-events: none;
    }

    @media screen and (max-width: 420px)
    {
        padding: 20px 15px;
    }
`;

export const FormSection = styled.div`
    margin-bottom: 25px;
    cursor: default;

    &:last-child
    {
        margin-bottom: 0;
    }

    h3
    {
        font-size: 18px;
        font-weight: 600;
        color: #2a4143;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 2px solid #e9eff2;
    }

    p
    {
        font-size: 14px;
        color: #5f7172;
    }
`;

export const FormRow = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 15px;
    flex-wrap: wrap;

    &:last-child
    {
        margin-bottom: 0;
    }

    @media screen and (max-width: 1200px)
    {
        gap: 15px;
    }

    @media screen and (max-width: 992px)
    {
        gap: 12px;
    }

    @media screen and (max-width: 768px)
    {
        flex-direction: column;
        gap: 15px;
    }
`;

export const FormField = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;

    @media screen and (max-width: 1200px)
    {
        flex: 1 1 calc(50% - 7.5px);
        min-width: 200px;
    }

    @media screen and (max-width: 992px)
    {
        flex: 1 1 calc(50% - 6px);
        min-width: 180px;
    }

    @media screen and (max-width: 768px)
    {
        flex: 1 1 100%;
        min-width: 100%;
    }
`;

export const ToggleRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
`;

export const ToggleRowLabel = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: #2a4143;
    cursor: default;
`;

export const SinglePhoneHelpText = styled.p`
    font-size: 12px !important;
    margin-top: 8px;
    color: #605e5c !important;
`;

export const FormLabel = styled.label<{ required?: boolean }>`
    font-size: 14px;
    font-weight: 500;
    color: #2a4143;
    margin-bottom: 6px;
    cursor: default;

    ${(props) => props.required && `
        &::after
        {
            content: " *";
            color: #CC214F;
        }
    `}
`;

export const FormInput = styled.input<{$pendingHighlight?: boolean; $errorHighlight?: boolean}>`
    padding: 10px 12px;
    font-size: 14px;
    border: 1px solid ${(props) => props.theme?.palette?.inputBorder ?? "#d1d9db"};
    border-radius: 8px;
    color: ${(props) => props.theme?.palette?.neutralPrimary ?? "#2a4143"};
    background-color: ${(props) => props.theme?.palette?.inputBackground ?? "#ffffff"} !important;
    transition: border-color 0.2s ease;

    ${(props) => props.$pendingHighlight && `
        border-color: #d4a012 !important;
        background-color: #fffbf0 !important;
        box-shadow: 0 0 0 1px rgba(212, 160, 18, 0.35);
    `}

    ${(props) => props.$errorHighlight && `
        border-color: #a4262c !important;
        background-color: #fde7e9 !important;
        box-shadow: 0 0 0 1px rgba(164, 38, 44, 0.35);
    `}

    &:focus
    {
        outline: none;
        border-color: ${(props) => props.theme?.palette?.themePrimary ?? "#CC214F"};
    }

    &:disabled
    {
        background-color: ${(props) => props.theme?.palette?.neutralLighter ?? "#f5f7f9"} !important;
        color: ${(props) => props.theme?.palette?.neutralTertiaryAlt ?? "#95a0a1"};
        cursor: not-allowed;
    }

    &::placeholder
    {
        color: #dbe5e8;
        font-style: italic;
        opacity: 1;
    }

    &[type="tel"]::placeholder
    {
        color: #dbe5e8;
        font-style: italic;
    }

    &[type="tel"]::-webkit-input-placeholder
    {
        color: #dbe5e8;
        font-style: italic;
    }

    &[type="tel"]::-moz-placeholder
    {
        color: #dbe5e8;
        font-style: italic;
        opacity: 1;
    }

    &[type="tel"]:-ms-input-placeholder
    {
        color: #dbe5e8;
        font-style: italic;
    }

    &[name="idDocument"]::placeholder
    {
        color: #dbe5e8;
        font-style: italic;
    }

    &[name="idDocument"]::-webkit-input-placeholder
    {
        color: #dbe5e8;
        font-style: italic;
    }

    &[name="idDocument"]::-moz-placeholder
    {
        color: #dbe5e8;
        font-style: italic;
        opacity: 1;
    }

    &[name="idDocument"]:-ms-input-placeholder
    {
        color: #dbe5e8;
        font-style: italic;
    }

    &[type="file"]
    {
        font-family: inherit;
        width: 100%;
        padding: 3px 5px;
        border: 1px solid ${(props) => props.theme?.palette?.inputBorder ?? "#95a0a1"};
        border-radius: 5px;
        position: relative;
        cursor: pointer;

        ${(props) => props.$pendingHighlight && `
            border-color: #d4a012 !important;
            background-color: #fffbf0 !important;
            box-shadow: 0 0 0 1px rgba(212, 160, 18, 0.35);
        `}

        &::file-selector-button
        {
            appearance: none;
            -webkit-appearance: none;
            margin-right: 12px;
            padding: 9px 14px;
            border: none;
            background-color: ${(props) => props.theme?.palette?.themePrimary ?? "#CC214F"};
            border-radius: 5px;
            color: ${(props) => props.theme?.palette?.white ?? "#ffffff"};
            font-size: 14px;
            cursor: pointer;
        }

        &:disabled
        {
            border: 1px solid ${(props) => props.theme?.palette?.neutralTertiaryAlt ?? "#cccccc"};

            &::file-selector-button
            {
                background-color: ${(props) => props.theme?.palette?.neutralTertiaryAlt ?? "#cccccc"};
                color: ${(props) => props.theme?.palette?.white ?? "#ffffff"};
                cursor: not-allowed;
            }
        }
    }
`;

export const FormSelect = styled.select<{$pendingHighlight?: boolean}>`
    box-sizing: border-box;
    height: 40px;
    min-height: 40px;
    padding: 0 12px;
    font-size: 14px;
    line-height: 1.2;
    border: 1px solid ${(props) => props.theme?.palette?.inputBorder ?? "#d1d9db"};
    border-radius: 8px;
    color: ${(props) => props.theme?.palette?.neutralPrimary ?? "#2a4143"};
    background-color: ${(props) => props.theme?.palette?.inputBackground ?? "#ffffff"} !important;
    cursor: pointer;
    transition: border-color 0.2s ease;

    ${(props) => props.$pendingHighlight && `
        border-color: #d4a012 !important;
        background-color: #fffbf0 !important;
        box-shadow: 0 0 0 1px rgba(212, 160, 18, 0.35);
    `}

    &:focus
    {
        outline: none;
        border-color: ${(props) => props.theme?.palette?.themePrimary ?? "#CC214F"};
    }

    &:disabled
    {
        background-color: ${(props) => props.theme?.palette?.neutralLighter ?? "#f5f7f9"} !important;
        color: ${(props) => props.theme?.palette?.neutralTertiaryAlt ?? "#95a0a1"};
        cursor: not-allowed;
    }
`;

/** Resalta grupos de opciones (p. ej. radio) cuando falta completar manualmente tras el documento. */
export const PendingFieldShell = styled.div<{ $pendingHighlight?: boolean }>`
    ${(props) => props.$pendingHighlight && `
        padding: 8px 10px;
        border-radius: 8px;
        border: 1px solid #d4a012;
        background-color: #fffbf0;
        box-shadow: inset 0 0 0 1px rgba(212, 160, 18, 0.2);
    `}
`;

export const FormTextarea = styled.textarea`
    padding: 10px 12px;
    font-size: 14px;
    border: 1px solid ${(props) => props.theme?.palette?.inputBorder ?? "#d1d9db"};
    border-radius: 8px;
    color: ${(props) => props.theme?.palette?.neutralPrimary ?? "#2a4143"};
    background-color: ${(props) => props.theme?.palette?.inputBackground ?? "#ffffff"} !important;
    resize: vertical;
    min-height: 80px;
    transition: border-color 0.2s ease;

    &:focus
    {
        outline: none;
        border-color: ${(props) => props.theme?.palette?.themePrimary ?? "#CC214F"};
    }

    &::placeholder
    {
        color: #dbe5e8;
        font-style: italic;
        opacity: 1;
    }
`;

export const FormCheckbox = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    input[type="checkbox"]
    {
        width: 18px;
        height: 18px;
        cursor: pointer;
        accent-color: #CC214F;
    }

    label
    {
        font-size: 14px;
        color: #5f7172;
        cursor: pointer;
    }
`;

export const ButtonsRow = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    margin-top: 20px;
    flex-wrap: wrap;

    button
    {
        white-space: nowrap;
        min-width: fit-content;
    }

    @media screen and (max-width: 480px)
    {
        flex-direction: column-reverse;
        align-items: stretch;
        
        button
        {
            width: 100%;
        }
    }
`;

export const SaveActionsInfo = styled.div`
    margin-top: 8px;
    margin-bottom: 12px;
    padding: 14px 16px;
    border-radius: 8px;
    border-left: 4px solid #1565c0;
    background-color: rgba(21, 101, 192, 0.08);
    color: #2a4143;
    font-size: 13px;
    line-height: 1.45;
    cursor: default;

    p
    {
        margin: 0;
    }

    p + p
    {
        margin-top: 8px;
    }
`;

export const ErrorMessage = styled.div`
    background-color: #fdecea;
    border: 1px solid #f5c6cb;
    color: #721c24;
    padding: 12px 15px;
    border-radius: 8px;
    margin-bottom: 20px;
    font-size: 14px;
`;

export const SuccessMessage = styled.div`
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    color: #155724;
    padding: 12px 15px;
    border-radius: 8px;
    margin-bottom: 20px;
    font-size: 14px;
`;

// Misma paleta que el $pendingHighlight de los inputs: el aviso debe verse igual que lo que anuncia.
export const PendingFieldsNotice = styled.div`
    background-color: #fffbf0;
    border: 1px solid #d4a012;
    color: ${(props) => props.theme?.palette?.neutralPrimary ?? "#2a4143"};
    padding: 12px 15px;
    border-radius: 8px;
    margin-bottom: 20px;
    font-size: 14px;
`;

// Estilos para la sección de subida de documentos
export const DocumentUploadSection = styled.div`
    margin-top: 15px;
`;

export const DocumentUploadRow = styled.div`
    display: flex;
    gap: 30px;
    margin-bottom: 30px;

    @media screen and (max-width: 768px)
    {
        flex-direction: column;
        gap: 20px;
    }
`;

export const DocumentUploadField = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const DocumentPreview = styled.div`
    margin-top: 10px;
    width: 100%;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f7f9;
    border: 2px dashed #d1d9db;
    border-radius: 8px;
    padding: 15px;
    overflow: hidden;

    img
    {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }

    span
    {
        font-size: 13px;
        color: #5f7172;
        word-break: break-all;
        text-align: center;
    }
`;

export const DocumentPlaceholder = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #95a0a1;

    span
    {
        font-size: 14px;
        font-weight: 500;
    }
`;

// Estilos para IdentityErrorHelper
export const ErrorHelperContainer = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    align-items: flex-start;

    @media screen and (max-width: 768px)
    {
        flex-direction: column;
    }
`;

export const ErrorListContainer = styled.div`
    flex: 1;
    background-color: #fdecea;
    border: 1px solid #f5c6cb;
    border-radius: 8px;
    padding: 15px 20px;
`;

export const ErrorListTitle = styled.h4`
    color: #721c24;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    cursor: default;
    gap: 8px;

    &::before
    {
        content: "⚠";
        font-size: 16px;
    }
`;

export const ErrorList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`;

export const ErrorItem = styled.li`
    color: #721c24;
    font-size: 13px;
    padding: 4px 0;
    padding-left: 20px;
    position: relative;

    &::before
    {
        content: "•";
        position: absolute;
        left: 8px;
        color: #CC214F;
    }
`;

export const HelpButtonContainer = styled.div`
    flex-shrink: 0;

    @media screen and (max-width: 768px)
    {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }
`;

/** Banner de aviso no bloqueante (warning) del servidor, p. ej. EXISTS_ACTIVE_IN_USER. */
export const ServerWarningBanner = styled.div`
    margin-bottom: 12px;
    padding: 10px 14px;
    border-radius: 4px;
    border-left: 4px solid #f57c00;
    background-color: rgba(255, 152, 0, 0.10);
    color: #e65100;
    font-size: 14px;
    line-height: 1.4;
    cursor: default;
`;

/** Banner de flujo informativo (acción requerida por el orquestador, no bloqueante de error). */
export const FlowInfoBanner = styled.div`
    margin-bottom: 12px;
    padding: 10px 14px;
    border-radius: 4px;
    border-left: 4px solid #1565c0;
    background-color: rgba(21, 101, 192, 0.08);
    color: #1565c0;
    font-size: 14px;
    line-height: 1.4;
    cursor: default;
`;

/** Contenedor de un flujo especial que oculta el formulario estándar (RequestAccess, etc.). */
export const FlowActionContainer = styled.div`
    background: ${(props) => props.theme.palette.tertiary};
    width: 100%;
    padding: 30px;
    border-radius: 20px;
    margin-bottom: 20px;

    p
    {
        font-size: 15px;
        font-weight: 600;
        color: #2a4143;
        margin-bottom: 18px;
    }

    p.flow-subtitle
    {
        font-size: 13px;
        font-weight: 400;
        color: #5f7172;
        margin-top: -12px;
        margin-bottom: 18px;
    }

    @media screen and (max-width: 420px)
    {
        padding: 20px 15px;
    }
`;

export const AnalyzingStatusOverlay = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default;
    gap: 12px;
    padding: 24px 16px;
    color: ${(props) => props.theme?.palette?.neutralSecondary ?? "#5f7172"};
    font-size: 14px;
`;

// ─── IdentityDocumentUpload ───────────────────────────────────────────────────

export const DocumentSectionTitle = styled.h3`
    font-size: 16px;
    font-weight: 600;
    color: #2a4143;
    margin-bottom: 6px;
`;

export const DocumentSectionDescription = styled.p`
    color: #5f7172;
    margin-bottom: 15px;
    cursor: default;
`;

export const DocumentFormatHint = styled.p`
    font-size: 11px;
    color: #95a0a1;
    margin-top: 4px;
`;

export const ProcessButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
`;

export const DniManualBanner = styled.div`
    margin-top: 20px;
    padding: 16px;
    border: 1px solid #e0a800;
    border-radius: 4px;
    background: #fffbea;
`;

export const DniManualBannerTitle = styled.p`
    font-weight: 600;
    margin-bottom: 8px;
    color: #7a5c00;
`;

export const DniManualBannerSubtitle = styled.p`
    font-size: 13px;
    color: #5f7172;
    margin-bottom: 12px;
`;

export const DniManualInputRow = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 8px;
    flex-wrap: wrap;
`;

export const DniManualInputCol = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const DniManualInputError = styled.span`
    font-size: 12px;
    color: #c0392b;
`;

export const DniManualConfirmButton = styled.button`
    padding: 8px 24px;
    font-size: 14px;
    font-family: Barlow, sans-serif;
    font-weight: 600;
    background: #CC214F;
    color: #fff;
    border: none;
    border-radius: 16px;
    cursor: pointer;
    line-height: 1.4;
    white-space: nowrap;

    &:hover
    {
        background: #a81a3f;
    }

    &:active
    {
        background: #8e1535;
    }
`;

export const DocumentProcessedMessage = styled.p`
    color: #2e7d32;
    font-weight: 600;
    margin-top: 10px;
`;